import OEIconCodes from '../../../lib/oe-icon-codes';
import {OETargetMenuDefs} from '../../elements/target-menu/oe-target-menu-defs';
import {OEAlphaBetaProdTypes} from '../oe-proto-model';

export const OECellTargetType = {
    cells:        'cells'
};

OECellTargetType.all = [
    OECellTargetType.cells
];

export const OECellStartSelectionContent = {

    // alpha
    [OECellTargetType.cells]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.animalCell,
                        OETargetMenuDefs.plantCell
                    ]
                }
            ]
        }
    ],

    // beta
    [OECellTargetType.cells + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.animalCell,
                        OETargetMenuDefs.plantCell
                    ]
                }
            ]
        }
    ],

    // prod
    [OECellTargetType.cells + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.animalCell,
                        OETargetMenuDefs.plantCell
                    ]
                }
            ]
        }
    ]
};

OECellStartSelectionContent.modules = [
    {id: OECellTargetType.cells, icon: OEIconCodes.cell.cellsTarget, categories: OECellStartSelectionContent[OECellTargetType.cells]},
];

OECellStartSelectionContent.modulesBeta = [
    {id: OECellTargetType.cells, icon: OEIconCodes.cell.cellsTarget, categories: OECellStartSelectionContent[OECellTargetType.cells + OEAlphaBetaProdTypes.beta]},
];

OECellStartSelectionContent.modulesProduction = [
    {id: OECellTargetType.cells, icon: OEIconCodes.cell.cellsTarget, categories: OECellStartSelectionContent[OECellTargetType.cells + OEAlphaBetaProdTypes.prod]},
];
